/**
 * @author gll
 * 功能：客户授信
 */

import { Service } from '@/tools'

export class CustomerCreditService<T extends TCustomer.CustomerCredit> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCustomer.CustomerCredit}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /*
  分页查询客户授信列表
  /api/customer/customerCredit/v1/customerCreditPage
  */
  customerCreditPage = <K extends T['ApiCustomerCreditPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCustomerCreditPage', data)

  /*
  新建客户授信
  /api/customer/customerCredit/v1/addCustomerCredit
  */
  addCustomerCredit = <K extends T['ApiAddCustomerCredit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddCustomerCredit', data)

  /*
  客户授信编辑
  /api/customer/customerCredit/v1/updateCustomerCredit
  */
  updateCustomerCredit = <K extends T['ApiUpdateCustomerCredit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCustomerCredit', data)

  /*
  客户授信变更
  /api/customer/customerCredit/v1/changeCustomerCredit
  */
  changeCustomerCredit = <K extends T['ApiChangeCustomerCredit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiChangeCustomerCredit', data)

  /*
  客户授信详情查看
  /api/customer/customerCredit/v1/customerCreditDetail
  */
  customerCreditDetail = <K extends T['ApiCustomerCreditDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCustomerCreditDetail', data)

  /*
  客户授信解冻
  /api/customer/customerCredit/v1/unfreezeCustomerCredit
  */
  unfreezeCustomerCredit = <K extends T['ApiUnfreezeCustomerCredit']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUnfreezeCustomerCredit', data)

  /*
  客户授信冻结
  /api/customer/customerCredit/v1/freezeCustomerCredit
  */
  freezeCustomerCredit = <K extends T['ApiFreezeCustomerCredit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFreezeCustomerCredit', data)

  /*
  撤销客户授信
  /api/customer/customerCredit/v1/revokeCustomerCreditLine
  */
  revokeCustomerCreditLine = <K extends T['ApiRevokeCustomerCreditLine']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiRevokeCustomerCreditLine', data)

  /*
  删除客户授信
  /api/customer/customerCredit/v1/deleteCustomerCredit
  */
  deleteCustomerCredit = <K extends T['ApiDeleteCustomerCredit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteCustomerCredit', data)

  /*
  客户授信唯一id校验
  //api/customer/customerCredit/v1/checkRepeatedCustomerCredit
  */

  checkRepeatedCustomerCredit = <K extends T['ApiCheckRepeatedCustomerCredit']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiCheckRepeatedCustomerCredit', data)

  /**
   * 查询授信流水记录
   *api/customer/customerCredit/v1/customerCreditBalanceChangeLog
   */
  customerCreditBalanceChangeLog = <K extends T['ApiCustomerCreditBalanceChangeLog']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiCustomerCreditBalanceChangeLog', data)
}
